// extracted by mini-css-extract-plugin
export default {"iconButton":"CourseRow_iconButton__eBlZl","icon":"CourseRow_icon__KNqxv"};